// @generated by protoc-gen-es v1.10.0 with parameter "target=ts"
// @generated from file penumbra/core/component/compact_block/v1/compact_block.proto (package penumbra.core.component.compact_block.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck
import { Message, proto3, protoInt64 } from "@bufbuild/protobuf";
import { CommitmentSource, Nullifier } from "../../sct/v1/sct_pb.js";
import { MerkleRoot, StateCommitment } from "../../../../crypto/tct/v1/tct_pb.js";
import { FmdParameters, NotePayload } from "../../shielded_pool/v1/shielded_pool_pb.js";
import { BatchSwapOutputData, SwapPayload } from "../../dex/v1/dex_pb.js";
import { GasPrices } from "../../fee/v1/fee_pb.js";
/**
 * Contains the minimum data needed to update client state.
 *
 * @generated from message penumbra.core.component.compact_block.v1.CompactBlock
 */
export class CompactBlock extends Message {
    /**
     * @generated from field: uint64 height = 1;
     */
    height = protoInt64.zero;
    /**
     * State payloads describing new state fragments.
     *
     * @generated from field: repeated penumbra.core.component.compact_block.v1.StatePayload state_payloads = 2;
     */
    statePayloads = [];
    /**
     * Nullifiers identifying spent notes.
     *
     * @generated from field: repeated penumbra.core.component.sct.v1.Nullifier nullifiers = 3;
     */
    nullifiers = [];
    /**
     * The block root of this block.
     *
     * @generated from field: penumbra.crypto.tct.v1.MerkleRoot block_root = 4;
     */
    blockRoot;
    /**
     * The epoch root of this epoch (only present when the block is the last in an epoch).
     *
     * @generated from field: penumbra.crypto.tct.v1.MerkleRoot epoch_root = 5;
     */
    epochRoot;
    /**
     * If a proposal started voting in this block, this is set to `true`.
     *
     * @generated from field: bool proposal_started = 6;
     */
    proposalStarted = false;
    /**
     * Latest Fuzzy Message Detection parameters.
     *
     * @generated from field: penumbra.core.component.shielded_pool.v1.FmdParameters fmd_parameters = 7;
     */
    fmdParameters;
    /**
     * Price data for swaps executed in this block.
     *
     * @generated from field: repeated penumbra.core.component.dex.v1.BatchSwapOutputData swap_outputs = 8;
     */
    swapOutputs = [];
    /**
     * Indicates updated app parameters.
     *
     * @generated from field: bool app_parameters_updated = 9;
     */
    appParametersUpdated = false;
    /**
     * Updated gas prices, if they have changed.
     *
     * @generated from field: penumbra.core.component.fee.v1.GasPrices gas_prices = 10;
     */
    gasPrices;
    /**
     * Updated gas prices for alternative fee tokens, if they have changed.
     *
     * @generated from field: repeated penumbra.core.component.fee.v1.GasPrices alt_gas_prices = 100;
     */
    altGasPrices = [];
    /**
     * The epoch index
     *
     * @generated from field: uint64 epoch_index = 11;
     */
    epochIndex = protoInt64.zero;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.compact_block.v1.CompactBlock";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 2, name: "state_payloads", kind: "message", T: StatePayload, repeated: true },
        { no: 3, name: "nullifiers", kind: "message", T: Nullifier, repeated: true },
        { no: 4, name: "block_root", kind: "message", T: MerkleRoot },
        { no: 5, name: "epoch_root", kind: "message", T: MerkleRoot },
        { no: 6, name: "proposal_started", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
        { no: 7, name: "fmd_parameters", kind: "message", T: FmdParameters },
        { no: 8, name: "swap_outputs", kind: "message", T: BatchSwapOutputData, repeated: true },
        { no: 9, name: "app_parameters_updated", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
        { no: 10, name: "gas_prices", kind: "message", T: GasPrices },
        { no: 100, name: "alt_gas_prices", kind: "message", T: GasPrices, repeated: true },
        { no: 11, name: "epoch_index", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    ]);
    static fromBinary(bytes, options) {
        return new CompactBlock().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompactBlock().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompactBlock().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompactBlock, a, b);
    }
}
/**
 * An encrypted payload, corresponding to a single commitment in the state commitment tree.
 *
 * @generated from message penumbra.core.component.compact_block.v1.StatePayload
 */
export class StatePayload extends Message {
    /**
     * The source of the payload, if known.
     *
     * @generated from field: penumbra.core.component.sct.v1.CommitmentSource source = 1;
     */
    source;
    /**
     * The state payload itself.
     *
     * @generated from oneof penumbra.core.component.compact_block.v1.StatePayload.state_payload
     */
    statePayload = { case: undefined };
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.compact_block.v1.StatePayload";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "source", kind: "message", T: CommitmentSource },
        { no: 2, name: "rolled_up", kind: "message", T: StatePayload_RolledUp, oneof: "state_payload" },
        { no: 3, name: "note", kind: "message", T: StatePayload_Note, oneof: "state_payload" },
        { no: 4, name: "swap", kind: "message", T: StatePayload_Swap, oneof: "state_payload" },
    ]);
    static fromBinary(bytes, options) {
        return new StatePayload().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StatePayload().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StatePayload().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StatePayload, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.compact_block.v1.StatePayload.RolledUp
 */
export class StatePayload_RolledUp extends Message {
    /**
     * @generated from field: penumbra.crypto.tct.v1.StateCommitment commitment = 1;
     */
    commitment;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.compact_block.v1.StatePayload.RolledUp";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "commitment", kind: "message", T: StateCommitment },
    ]);
    static fromBinary(bytes, options) {
        return new StatePayload_RolledUp().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StatePayload_RolledUp().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StatePayload_RolledUp().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StatePayload_RolledUp, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.compact_block.v1.StatePayload.Note
 */
export class StatePayload_Note extends Message {
    /**
     * @generated from field: penumbra.core.component.shielded_pool.v1.NotePayload note = 2;
     */
    note;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.compact_block.v1.StatePayload.Note";
    static fields = proto3.util.newFieldList(() => [
        { no: 2, name: "note", kind: "message", T: NotePayload },
    ]);
    static fromBinary(bytes, options) {
        return new StatePayload_Note().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StatePayload_Note().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StatePayload_Note().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StatePayload_Note, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.compact_block.v1.StatePayload.Swap
 */
export class StatePayload_Swap extends Message {
    /**
     * @generated from field: penumbra.core.component.dex.v1.SwapPayload swap = 2;
     */
    swap;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.compact_block.v1.StatePayload.Swap";
    static fields = proto3.util.newFieldList(() => [
        { no: 2, name: "swap", kind: "message", T: SwapPayload },
    ]);
    static fromBinary(bytes, options) {
        return new StatePayload_Swap().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new StatePayload_Swap().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new StatePayload_Swap().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(StatePayload_Swap, a, b);
    }
}
/**
 * Requests a range of compact block data.
 *
 * @generated from message penumbra.core.component.compact_block.v1.CompactBlockRangeRequest
 */
export class CompactBlockRangeRequest extends Message {
    /**
     * The start height of the range.
     *
     * @generated from field: uint64 start_height = 2;
     */
    startHeight = protoInt64.zero;
    /**
     * The end height of the range, defaults to the latest block height.
     *
     * @generated from field: uint64 end_height = 3;
     */
    endHeight = protoInt64.zero;
    /**
     * If set, keeps the connection alive past `end_height`,
     * streaming new compact blocks as they are created.
     *
     * @generated from field: bool keep_alive = 4;
     */
    keepAlive = false;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.compact_block.v1.CompactBlockRangeRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 2, name: "start_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 3, name: "end_height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
        { no: 4, name: "keep_alive", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    ]);
    static fromBinary(bytes, options) {
        return new CompactBlockRangeRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompactBlockRangeRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompactBlockRangeRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompactBlockRangeRequest, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.compact_block.v1.CompactBlockRangeResponse
 */
export class CompactBlockRangeResponse extends Message {
    /**
     * @generated from field: penumbra.core.component.compact_block.v1.CompactBlock compact_block = 1;
     */
    compactBlock;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.compact_block.v1.CompactBlockRangeResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "compact_block", kind: "message", T: CompactBlock },
    ]);
    static fromBinary(bytes, options) {
        return new CompactBlockRangeResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompactBlockRangeResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompactBlockRangeResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompactBlockRangeResponse, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.compact_block.v1.CompactBlockRequest
 */
export class CompactBlockRequest extends Message {
    /**
     * @generated from field: uint64 height = 1;
     */
    height = protoInt64.zero;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.compact_block.v1.CompactBlockRequest";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "height", kind: "scalar", T: 4 /* ScalarType.UINT64 */ },
    ]);
    static fromBinary(bytes, options) {
        return new CompactBlockRequest().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompactBlockRequest().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompactBlockRequest().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompactBlockRequest, a, b);
    }
}
/**
 * @generated from message penumbra.core.component.compact_block.v1.CompactBlockResponse
 */
export class CompactBlockResponse extends Message {
    /**
     * @generated from field: penumbra.core.component.compact_block.v1.CompactBlock compact_block = 1;
     */
    compactBlock;
    constructor(data) {
        super();
        proto3.util.initPartial(data, this);
    }
    static runtime = proto3;
    static typeName = "penumbra.core.component.compact_block.v1.CompactBlockResponse";
    static fields = proto3.util.newFieldList(() => [
        { no: 1, name: "compact_block", kind: "message", T: CompactBlock },
    ]);
    static fromBinary(bytes, options) {
        return new CompactBlockResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CompactBlockResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CompactBlockResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CompactBlockResponse, a, b);
    }
}
